import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carLock"
const CarLockIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.364 7.484C18.516 4.795 16.844 3 14.5 3h-7C5.14 3 3.46 4.82 2.618 7.539a1.75 1.75 0 1 0-.59 3.447C2.01 11.32 2 11.657 2 12v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h4v-1.003c0-.886.387-1.682 1-2.231V13c0-1.093.292-2.117.803-3H4.5c0-1 0-5 3.5-5h6c1.685 0 2.559.927 3.012 2a5.98 5.98 0 0 1 2.352.484ZM5.5 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.997v5.006a1 1 0 0 0 .995.997h8.01c.54 0 .995-.446.995-.997v-5.006a1 1 0 0 0-.995-.997L21 13a4 4 0 0 0-8 0v2c-.544 0-1 .446-1 .997ZM15 13v2h4v-2a2 2 0 1 0-4 0Z"
      />
    </svg>
  )
}
export default CarLockIcon
